import React from 'react';
import { Link } from 'react-router';
import MenuItem from 'material-ui/MenuItem';
import PropTypes from 'prop-types';
import EditableCategorizedItemList from './EditableCategorizedItemList';
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import {adminCardStyle} from '../containers/AdminHomepage';

class OptionList extends React.Component {

  constructor(props) {
    super(props);
    this.onItemClick = this.onItemClick.bind(this);
    this.state = {
      categoryType: "category"
    }
  }

  render() {
    let props = this.props;
    let section = props.routeParams.section || "monitoring";
    let categories = props.categories.filter((c) => c.type === "option" || c.type === "target");
    let catType = props.routeParams.section === "assessment" ? this.state.categoryType : "category"
    if(catType === "category"){
      categories = categories.filter((c) => !c.inputCategory);
    } else {
      categories = categories.filter((c) => c.inputCategory);
    }

    return (
      <div>
        {
          props.routeParams.section === "assessment" &&
          <div style={{...adminCardStyle, backgroundColor:"white"}}>
            <RadioButtonGroup onChange={this.onCategoryTypeChange.bind(this)} name="categoryType" valueSelected={this.state.categoryType || "category"} style={{paddingLeft: 16, marginBottom: 22}}>
              <RadioButton
                value="category"
                label="Assessment Output"
              />
              <RadioButton
                value="inputCategory"
                label="Assessment Categories"
              />
            </RadioButtonGroup>
          </div>
        }
        <EditableCategorizedItemList
          categories={categories}
          items={props.options}
          itemFilter={(item) => item.section === section}
          deleteCategoryAction={props.deleteCategory}
          categoryType={catType}
          onItemClick={this.onItemClick}
          fabItems={[
            <MenuItem key="mi1" primaryText="New Category" containerElement={<Link to="/admin/categories/create/option" />} />,
            <MenuItem key="mi2" primaryText="New Option" containerElement={<Link to="/admin/options/create" />} />
          ]}
        />
      </div>
    )
  }

  onItemClick(id) {
    this.props.router.push("/admin/options/edit/" + id);
  }

  onCategoryTypeChange(e, value){
    this.setState({
      categoryType: value
    })
  }
}

OptionList.propTypes = {
  options: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  deleteCategory: PropTypes.func.isRequired
}

export default OptionList;
